import { render, staticRenderFns } from "./DialogPurchaseAiRequests.vue?vue&type=template&id=50e0a819"
import script from "./DialogPurchaseAiRequests.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseAiRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports